import { faArrowUp } from '@fortawesome/free-solid-svg-icons';

export const billingConfig = {
  defaultSortedColumn: {
    column: 'ActivityDate',
    asc: true,
    icon: faArrowUp,
  },
  columns: [
    {
      columnKey: 'InsuredName',
      columnDataHeader: 'insuredName',
      columnDisplayText: 'Insured Name',
      columnVariant: null,
    },
    {
      columnKey: 'PolicyNumber',
      columnDataHeader: 'policyNumber',
      columnDisplayText: 'Policy',
      columnVariant: 'navigational',
    },
    {
      columnKey: 'ActivityType',
      columnDataHeader: 'activityType',
      columnDisplayText: 'Activity',
      columnVariant: null,
      hasFilter: true,
    },
    {
      columnKey: 'ActivityDate',
      columnDataHeader: 'activityDate',
      columnDisplayText: 'Activity Date',
      columnVariant: null,
    },
    {
      columnKey: 'MinimumDue',
      columnDataHeader: 'minimumDue',
      columnDisplayText: 'Minimum Due',
      columnVariant: null,
    },
    {
      columnKey: 'AgencyName',
      columnDataHeader: 'agencyName',
      columnDisplayText: 'Agency',
      columnVariant: null,
      hasFilter: true,
    },
    {
      columnKey: 'AgencyCode',
      columnDataHeader: 'agencyCode',
      columnDisplayText: 'Agency Code',
      columnVariant: null,
      hasFilter: true,
    },
  ],
};

export const claimsConfig = {
  defaultSortedColumn: {
    column: 'ActivityDate',
    asc: true,
    icon: faArrowUp,
  },
  columns: [
    {
      columnKey: 'InsuredName',
      columnDataHeader: 'insuredName',
      columnDisplayText: 'Insured Name',
      columnVariant: null,
    },
    {
      columnKey: 'PolicyNumber',
      columnDataHeader: 'policyNumber',
      columnDisplayText: 'Policy',
      columnVariant: null,
    },
    {
      columnKey: 'ClaimNumberName',
      columnDataHeader: 'claimsNumber',
      columnDisplayText: 'Claim Number',
      columnVariant: 'navigational',
    },
    {
      columnKey: 'ActivityType',
      columnDataHeader: 'activityType',
      columnDisplayText: 'Activity',
      columnVariant: null,
      hasFilter: true,
    },
    {
      columnKey: 'ActivityDate',
      columnDataHeader: 'activityDate',
      columnDisplayText: 'Activity Date',
      columnVariant: null,
    },
    {
      columnKey: 'AgencyName',
      columnDataHeader: 'agencyName',
      columnDisplayText: 'Agency',
      columnVariant: null,
      hasFilter: true,
    },
    {
      columnKey: 'AgencyCode',
      columnDataHeader: 'agencyCode',
      columnDisplayText: 'Agency Code',
      columnVariant: null,
      hasFilter: true,
    },
  ],
};

export const policyConfig = {
  defaultSortedColumn: {
    column: 'ActivityDate',
    asc: true,
    icon: faArrowUp,
  },
  columns: [
    {
      columnKey: 'InsuredName',
      columnDataHeader: 'insuredName',
      columnDisplayText: 'Insured Name',
      columnVariant: null,
    },
    {
      columnKey: 'PolicyNumber',
      columnDataHeader: 'policyNumber',
      columnDisplayText: 'Policy',
      columnVariant: 'navigational',
    },
    {
      columnKey: 'TransactionType',
      columnDataHeader: 'activityType',
      columnDisplayText: 'Activity',
      columnVariant: null,
      hasFilter: true,
    },
    {
      columnKey: 'ActivityDate',
      columnDataHeader: 'activityDate',
      columnDisplayText: 'Activity Date',
      columnVariant: null,
    },
    {
      columnKey: 'AgencyName',
      columnDataHeader: 'agencyName',
      columnDisplayText: 'Agency',
      columnVariant: null,
      hasFilter: true,
    },
    {
      columnKey: 'AgencyCode',
      columnDataHeader: 'agencyCode',
      columnDisplayText: 'Agency Code',
      columnVariant: null,
      hasFilter: true,
    },
  ],
};
